export default __webpack_public_path__ + "static/media/broccoli3.8f0e4355.jpg";